import { Theme } from "@mui/material/styles";
import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  bodyContainer: {
    display: "flex",
    flexDirection: "column",
    height: `calc(100% - ${theme.spacing.spacing28})`,
    alignItems: "center",
    justifyContent: "flex-start",
    overflowY: "auto",
  },
  bodyTitle: {
    margin: `0px 0 ${theme.spacing.spacing5} 0`,
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.size.md,
  },
  bodyText: {
    padding: `0 ${theme.spacing.spacing7}`,
    fontSize: theme.typography.size.md,
    textAlign: "center",
    lineHeight: "23px",
  },
  bodyImage: {
    marginTop: 5,
    // marginLeft: "-48px"
  },
}));
